import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className"];
import React from 'react';
import PropTypes from 'prop-types';
import PageBody from './PageBody';
import PageHeader from './PageHeader';
import PageFooter from './PageFooter';
var Page = function Page(_ref) {
  var children = _ref.children,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "".concat(className, " relative"),
    sectiontype: "container-section"
  }, extraProps), children);
};
Page.Header = PageHeader;
Page.Body = PageBody;
Page.Footer = PageFooter;
Page.propTypes = {
  children: PropTypes.array,
  className: PropTypes.string
};
Page.defaultProps = {
  children: null,
  className: ''
};
export default Page;